import api from '../services/api.service';
import { API_ROUTES } from '../constants/apiRoutes';
import { extractData } from './helpers';

const schema = {
  getUserTotalTimeRequest: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.ME, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getUsersTotalTimeRequest: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.USERS, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getProjectTotalTimeRequest: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.PROJECTS_TOTAL_TIME, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getStatsReport: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.USER_REPORT, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getProjectsTaskCrudRequest: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.PROJECTS_TASK_CRUD, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getUserAutocomplete: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.ACTIVITY.USER_AUTOCOMPLETE, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getTodayDailyLogs: async (params = {}) => {
    try {
      const response = await api.get(API_ROUTES.DAILY_LOGS.ALL, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getDailyLogsByUser: async (params = {}) => {
    const route = params.userId
      ? `${API_ROUTES.DAILY_LOGS.INDEX}/${params.userId}`
      : API_ROUTES.DAILY_LOGS.INDEX;

    try {
      const response = await api.get(route, {
        date: params.date,
      });
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  submitDailyLog: async (body) => {
    try {
      const response = await api.post(API_ROUTES.DAILY_LOGS.INDEX, {
        ...body,
      });
      return extractData(response);
    } catch (error) {
      throw new Error(error.response.data.result.message ?? 'Failed to submit daily logs');
    }
  },
  getDailyLogTemplates: async () => {
    try {
      const response = await api.get(API_ROUTES.DAILY_LOGS.TEMPLATES);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  submitDailyLogTemplate: async (body) => {
    try {
      const response = await api.post(API_ROUTES.DAILY_LOGS.TEMPLATES, {
        ...body,
      });
      return extractData(response);
    } catch (error) {
      throw new Error(error.response.data.result.message ?? 'Failed to submit daily log template');
    }
  },
  deleteDailyLogTemplate: async (templateId) => {
    try {
      const response = await api.delete(`${API_ROUTES.DAILY_LOGS.TEMPLATES}/${templateId}`);
      return extractData(response);
    } catch (error) {
      throw new Error(
        error.response?.data?.result?.message ?? 'Failed to delete daily log template',
      );
    }
  },
};

export default schema;
